import { render, staticRenderFns } from "./Top4BeautyOEM.vue?vue&type=template&id=2566fea2&scoped=true"
import script from "./Top4BeautyOEM.vue?vue&type=script&lang=js"
export * from "./Top4BeautyOEM.vue?vue&type=script&lang=js"
import style0 from "./Top4BeautyOEM.vue?vue&type=style&index=0&id=2566fea2&prod&lang=scss&scoped=true"
import style1 from "./Top4BeautyOEM.vue?vue&type=style&index=1&id=2566fea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566fea2",
  null
  
)

export default component.exports